/* eslint-disable */
import axios from 'axios';

class analytics {
  static apiCall(endpoint) {
    if (window.dataLayer == undefined) {
      // console.log('not sending api call analytics');
      return;
    }

    let userParam = window.location.pathname.match(/(u)(\d{1,})/g);
    if (!userParam) {
      return;
    }
    
    let userHash = localStorage.getItem(userParam[0]);
    if (window.userDetails) {
      let dataToSend = {
        configCode: window.userDetails['ConfigCode'],
        enpoint: endpoint,
        userId: window.userDetails['LoginUserId'],
        callTime: new Date().formatString('yyyy-MM-dd HH:mm:ss')
      };
      
      // gtag('event', 'apiCall6g', { apiDetails: JSON.s1tringify(dataToSend) })
      window.dataLayer.push({ event: 'gtag_api_call', apiDetails: dataToSend });
    } else {
      axios.get(`/Login/GetDetails?key=${userHash}`).then(r => {
        let result = r.data;
        window.userDetails = result;
        let dataToSend = {
          configCode: result['ConfigCode'],
          enpoint: endpoint,
          userId: result['LoginUserId'],
          callTime: new Date().formatString('yyyy-MM-dd HH:mm:ss')
        };
        
        // gtag('event', 'apiCall6g', { apiDetails: JSON.stringify(dataToSend) })
        window.dataLayer.push({ event: 'gtag_api_call', apiDetails: dataToSend });
      });
    }
  }
}

export default analytics;